const STATISTICS_API = {
    singleSuppliersStats: "/singleSuppliersStats",
    singleBatchStats: "/singleBatchStats",
    filletInfo: "Statistics/Fillet",
    quality: "Statistics/Quality",
    received: "/Statistics/IntakeReceived",
    colour: "/Statistics/FilletColor",
    getTotalBatches: "/Statistics/TotalBatches",
    getAveragePrice: "/Statistics/AveragePricePerKg",
    getTotalClaims: "/Statistics/TotalClaims",
    getIproveRate: "/Statistics/ImprovedAreaTrend",
    getIproveRateNew: "/Statistics/ImprovedAreaTrend-new",
    getTopIssue: "/Statistics/TopIssueTrend",
    getTopIssueNew: "/Statistics/TopIssueTrend-new",
    getDefectRate: "/Statistics/DefectRateTrend",
    getDefectRateNew: "/Statistics/DefectRateTrend-new",
    getFilletInfobatch: "/Statistics/FilletByBatchNo",
    getQualityInfoByBatch: "/Statistics/QualityStatsByBatchNo",
    getReceivedBybatch:"/Statistics/IntakeReceivedStatsByBatchNo",
    getColorBatch:"/Statistics/FilletColorByBatchNo",
    getVolumeStats:"/Statistics/FilletSize",
    getVolumeStatsByBatch:"/Statistics/GetFilletSizeByBatchNo",
    getWeightStats:"/Statistics/FilletWeightDistributionBySupplier",
    getWeightStatsByBatch:"/Statistics/FilletWeightDistributionByBatchNo",

  };
  
  export default STATISTICS_API;